module.exports = __webpack_public_path__ + "static/img/郑州警察学院.df6b1f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/郑州警察学院.jpg
// module id = y1/l
// module chunks = 1